import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 259234 292823"
    {...props}
  >
    <path
      d="M15976 137157c6261 7381 12531 14762 18870 22233C51942 90456 89625 36599 151170 0c-99 344-125 736-315 1016-11872 17518-14624 37081-12901 57626 1016 12109 4272 23732 7829 35285 7006 22750 10782 45965 9486 69821-370 6765-1455 13491-2304 21023 22397-33192 28249-69864 27409-108710 25863 21061 38623 49379 47128 81133 3035-4026 5387-7372 7979-10529 2631-3199 5486-6205 8815-8901-655 2515-1383 5017-1955 7549-1917 8432-853 16605 2420 24503 3109 7497 6476 14890 9654 22357 7700 18074 6227 35212-4866 51606-13534 19989-31517 35298-51239 49044 947-1968 2105-3863 2803-5917 4280-12656 9448-25114 12475-38076 6472-27654-2708-50968-22259-70734-219-219-551-336-1115-658-8819 30763-21449 59391-44651 82610-1008-5396-1352-10602-3010-15352-3790-10851-7347-21931-12583-32094-12130-23572-17802-48751-20721-74752-905-8048-1327-16148-2769-24498-10159 25915-20321 51830-30505 77814-4096-4375-8169-8716-12234-13057-181 164-362 323-534 487 818 3819 1886 7600 2398 11463 1279 9521-1847 18185-5568 26724-3281 7541-6791 15020-9465 22776-5796 16811-1765 31991 8703 45835 1322 1749 2666 3480 3639 5728-1667-1086-3359-2119-4983-3256-17913-12531-34492-26453-47553-44251-11747-16001-13319-32964-5736-51015 3019-7179 6235-14275 9319-21432 4448-10292 5202-20765 1442-31444-211-599-357-1219-534-1826 366-254 737-495 1107-741z"
      style={{
        fill: "#000",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
